import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import DateRange from "../../DateRange/DateRange";
import { dummyimage, Search_icon, view_icon } from "../../../assets/img";
import { Table } from "../../Table/Table";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { toast } from "react-toastify";

const BookingList = () => {
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [popup, setPopup] = useState(false);
  const [statusPopup, setStatusPopup] = useState(false);
  const [reason, setReason] = useState();
  const [state, setState] = useState();
  const [status, setStatus] = useState();
  const [city, setCity] = useState();
  const [currentStatus, setCurrentStatus] = useState();
  const [fromDate, setFormDate] = useState();
  const [toDate, setToDate] = useState();
  const [owners, setOwners] = useState([
    {
      "S.No": "01",
      adminID: "Rob90",
      name: "Robert Rob001",
      Owner: "Sathish (Rob90)",
      role: "Super Admin",
      state: "Tamil Nadu",
      city: "Chennai",
      count: "10",
      service: "Room Booking",
      category: "Standard",
      propPrice: "10,000",
      amount: "5,000",
      slot: "22hrs(M) (6am-4am)",
      balance: "5,000",
      date: "12/02/2025",
      fromDate: "12/02/2025",
      toDate: "12/02/2025",
      email: "robert@gmail.com",
      number: "2345678974",
      City: "Chennai",
      "Total Property Count": 12,
      status: "off",
      property: "Hotel1 h1092",
      type: "Villa",
      loc: "Anna Nagar",
      reqBy: "Owner",
      current_status: "1",
      status_booking: "1",
    },
    {
      "S.No": "01",
      adminID: "Thor91",
      name: "Thor Tho002",
      Owner: "Sathish (Rob90)",
      role: " Admin",
      state: "Tamil Nadu",
      city: "Chennai",
      count: "20",
      service: "Room Booking",
      category: "Standard",
      propPrice: "10,000",
      amount: "10,000",
      slot: "22hrs(M) (6am-4am)",
      balance: "-",
      date: "12/02/2025",
      fromDate: "12/02/2025",
      toDate: "12/02/2025",
      "Registered Date": "12/02/2025",
      email: "thor@gmail.com",
      number: "2345678974",
      City: "Chennai",
      "Total Property Count": 12,
      status: "off",
      property: "Hotel2 H08498",
      type: "Resort",
      loc: "T Nagar",
      reqBy: "Admin",
      current_status: "1",
      status_booking: "1",
    },
    {
      "S.No": "01",
      adminID: "Rob90",
      name: "Robert Rob003",
      Owner: "Sathish (Rob90)",
      role: " Admin",
      state: "Tamil Nadu",
      city: "Chennai",
      count: "10",
      service: "Room Booking",
      category: "Standard",
      propPrice: "10,000",
      amount: "5,000",
      slot: "22hrs(M) (6am-4am)",
      balance: "5,000",
      date: "12/02/2025",
      fromDate: "12/02/2025",
      toDate: "12/02/2025",
      "Registered Date": "12/02/2025",
      email: "robert@gmail.com",
      number: "2345678974",
      City: "Chennai",
      "Total Property Count": 12,
      status: "off",
      property: "Hotel3 H30489",
      type: "Villa",
      loc: "Anna Nagar",
      reqBy: "Owner",
      current_status: "1",
      status_booking: "1",
    },
  ]);

  const handleReason = () => {
    if (!reason) {
      toast.error("Enter Reason");
      return;
    }
    setStatusPopup(false);
  };

  const handleImageClick = () => {
    inputRef.current.click();
  };

  const handleChange = (ind, key_name, value) => {
    let temp = [...owners];
    temp[ind] = {
      ...temp[ind],
      [key_name]: value,
    };
    setOwners(temp);
  };

  const handleStatus = ({ id }) => {
    const updatedData = [...owners]; // Create a copy of the data
    const currentStatus = updatedData[id].status || "on"; // Default to "on" if undefined

    updatedData[id].status = currentStatus === "on" ? "off" : "on";
    setOwners(updatedData);
    console.log("KK", id);
    // let value = data.filter((ele, i) => i == id ? ele.status == "off" ? "on" : "off")
  };

  const users = [
    { id: 1, name: "Chennai", age: 28, city: "New York" },
    { id: 2, name: "Banglore", age: 34, city: "Los Angeles" },
    { id: 3, name: "Hyderabad", age: 22, city: "Chicago" },
    { id: 4, name: "Nellore", age: 25, city: "Miami" },
    { id: 5, name: "Guntur", age: 40, city: "San Francisco" },
  ];
  const ownerList = [
    { id: 1, name: "John Doe", age: 28, city: "New York" },
    { id: 2, name: "Jane Smith", age: 34, city: "Los Angeles" },
    { id: 3, name: "Sam Brown", age: 22, city: "Chicago" },
    { id: 4, name: "Emily Johnson", age: 25, city: "Miami" },
    { id: 5, name: "Michael Davis", age: 40, city: "San Francisco" },
  ];
  const options = users.map((item) => {
    let obj = {};
    obj.value = item.name;
    obj.label = item.name;
    return obj;
  });
  const ownerOptions = ownerList.map((item) => {
    let obj = {};
    obj.value = item.name;
    obj.label = item.name;
    return obj;
  });

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red">{(page - 1) * 10 + (row.index + 1)}</p>;
        },
      },
      {
        Header: " Booked ID",
        accessor: "adminID",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Booking Date",
        accessor: "date",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "User",
        accessor: "Owner",
        Cell: ({ value, row }) => {
          return <p className="primary pointer">{value}</p>;
        },
      },
      {
        Header: "No of Booked Rooms",
        accessor: "count",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Service Category",
        accessor: "service",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Room Category",
        accessor: "category",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "From date",
        accessor: "fromDate",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "To date",
        accessor: "toDate",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Property Price",
        accessor: "propPrice",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Paid Amount",
        accessor: "amount",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "Slot",
        accessor: "slot",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Balance Amount",
        accessor: "balance",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Current Status",
        accessor: "current_status",
        Cell: ({ value, row }) => {
          return (
            <select
              value={value}
              onChange={(e) => {
                const value = e.target.value;
                handleChange(row.index, "current_status", value);
                if (value === "2" || value === "3") {
                  setPopup(true);
                }
                setCurrentStatus(value);
              }}
              className="active-btn fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 w-100 p-2"
            >
              <option value={"1"}>Upcoming</option>
              <option value={"2"}>Check In</option>
              <option value={"3"}>Check Out</option>
            </select>
          );
        },
      },

      {
        Header: "Status",
        accessor: "status_booking",
        Cell: ({ value, row }) => {
          const allOptions = [
            { value: "1", label: "Booked" },
            { value: "2", label: "Cancelled" },
            { value: "3", label: "Hold" },
            { value: "4", label: "Release" },
          ];

          return (
            <select
              value={value}
              onChange={(e) => {
                setStatus(e.target.value);
                handleChange(row.index, "status_booking", e.target.value);
                if (["2", "3", "4"].includes(e.target.value)) {
                  setStatusPopup(e.target.value);
                }
              }}
              className={`${
                value === "1"
                  ? "active-btn"
                  : value === "2"
                  ? "deactive-btn"
                  : value === "3"
                  ? "hold-btn"
                  : "release-btn"
              } fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 p-2`}
              style={{ width: "100px" }}
            >
              {/* keep current value as the selected one */}
              <option value={value} style={{ display: "none" }}>
                {allOptions.find((opt) => opt.value === value)?.label}
              </option>

              {/* show only other options */}
              {allOptions
                .filter((opt) => opt.value !== value)
                .map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
            </select>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-js gap-3">
                {/* {givenpermissions?.includes("CAN-Edit-ADMINS") && ( */}
                <button
                  onClick={() => {
                    navigate("/room-list-view", { state: { type: "view" } });
                    // AdminView(row.original.id, "edit");
                  }}
                  className="cust-btn "
                >
                  <img src={view_icon} alt="" className=" edit-btn " />
                </button>
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [owners, page]
  );

  console.log("staus", status);

  return (
    <div>
      <div className="d-flex ac-jb w-100">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:3
        </h2>
        <div className="d-flex gap-3 w-50">
          <div className="roles-bg w-50 rounded-4">
            <h2 className=" f4 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18">
              Property Name: Sunroof
            </h2>
            <h2 className=" f4 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 ">
              Property ID: 234567
            </h2>
          </div>
          <div className="roles-bg w-50 rounded-4">
            <h2 className=" f4 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18">
              Owner Name: Sunroof
            </h2>
            <h2 className=" f4 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 ">
              Owner ID: 234567
            </h2>
          </div>
        </div>
      </div>
      <div className="d-flex ac-jb mt-3 gap-1 flex-wrap">
        <DateRange />
        <Select
          className="location-search"
          options={options}
          value={city}
          onChange={setCity}
          placeholder={"Check In"}
        />
        <Select
          className="location-search"
          options={ownerOptions}
          value={state}
          onChange={setState}
          placeholder={"Booked"}
        />
        <div className="search-input">
          <input
            //  onChange={(e) => (adminList(1, e.target.value))}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "180px" }}
          />
          <img src={Search_icon} className="search here" />
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={owners}
        show={true}
      />
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-je mb-4 ">
              <CancelOutlinedIcon
                className="pointer"
                onClick={() => {
                  setPopup(false);
                }}
              />
            </div>
            <div className="w-100 mt-3 d-flex flex-wrap ac-jc gap-4">
              <div className="w-80">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  ">
                  Enter the booking ID
                </p>
                <input
                  className="input-box mt-1 w-100"
                  value={"B23456"}
                  disabled
                  placeholder="Booking ID"
                />
              </div>
            </div>
            <div className="d-flex ac-jc  mt-5">
              <button onClick={() => setPopup(false)} className="submit-btn">
                submit
              </button>
            </div>
          </div>
        </div>
      )}
      {statusPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-je mb-4 ">
              <CancelOutlinedIcon
                className="pointer"
                onClick={() => {
                  setStatusPopup(false);
                }}
              />
            </div>
            <div className="w-100 mt-3 d-flex flex-wrap ac-jc gap-4">
              <div className="w-80">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  text-start">
                  {statusPopup == "2"
                    ? "Reason for cancel ?"
                    : statusPopup == "3"
                    ? "Hold Reason ?"
                    : statusPopup == "4"
                    ? "Reason for Release ?"
                    : ""}
                </p>
                <textarea
                  className="input-box mt-1 w-100"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Describe..."
                />
              </div>
            </div>
            <div className="d-flex ac-jc  mt-5">
              <button onClick={() => handleReason()} className="submit-btn">
                submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingList;
